import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['You pay every month to keep access', 'A routine performed at full speed, no class around it', 'Counts and cues you work out yourself', 'One level, rarely built for kids or drop-ins', 'You still plan the term and the show alone'];
const withIt = ['One payment, the files are yours', 'Complete Class Plans, warm-up to send-off', 'Every step written in 8-counts, with cues', 'Kids, beginner and recreational levels built in', 'Year Map, formations and showcase plan included'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-339" data-mp="2965ubpe4vd54">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" data-id="element-340" data-mp="2d8kcs8dw4avv">
        <div className="text-center" data-id="element-341" data-mp="2d6zkyqiyn61p">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-342" data-mp="30yn1ceiliypq">Why this isn&apos;t another routine library</p>
          <h2 id="vs-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-343" data-mp="35pn0lqf6tsve">
            Routine subscriptions vs <span className="wash-text" data-id="element-344" data-mp="1tgejy12gdqu9">ready classes</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-navy-soft" data-id="element-345" data-mp="1ogs7vuyd2gn1">
            Most Bollywood material for instructors is a monthly routine
            library or a song-by-song video. Useful, but the routine was never
            the hard part. Breaking it down, filling the class and knowing
            what comes next week, was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl shadow-card" data-id="element-346" data-mp="2837t0oldq0e0">
          <div className="bg-paper px-3.5 py-4 sm:p-6" data-id="element-347" data-mp="2m4abkrd60sk6">
            <h3 className="font-display text-base text-navy-muted sm:text-xl" data-id="element-348" data-mp="2m1o750lkmt66">
              A routine subscription or video course
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-349" data-mp="rr2eet1pw4vd">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-navy-soft sm:text-sm" data-id="element-350" data-mp="mrpqe4z40rr7">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-rose-soft" data-id="element-351" data-mp="2muqokidbbpqe">
                    <XIcon className="h-2.5 w-2.5 text-rose-deep" aria-hidden="true" data-id="element-352" data-mp="2rud26sx1z7zq" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-teal-soft px-3.5 py-4 sm:p-6" data-id="element-353" data-mp="30qufa1oz9fy4">
            <h3 className="font-display text-base text-teal-deep sm:text-xl" data-id="element-354" data-mp="35qyuloe5g4mr">
              Bollywood Class Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-355" data-mp="3ap0f8dr84c0c">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-semibold leading-snug text-navy sm:text-sm" data-id="element-356" data-mp="3fimu8ckv0rzb">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white" data-id="element-357" data-mp="3oije80wb12o1">
                    <CheckIcon className="h-2.5 w-2.5 text-teal-deep" aria-hidden="true" data-id="element-358" data-mp="3th2zs06zkcfv" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}